import { consoleWarn } from './consoleWarn';
export var replaceThemeToken = function replaceThemeToken(currentValue, theme, prefix, where) {
  var updated = false;
  var value = currentValue;

  if (typeof currentValue === 'string' && currentValue[0] === '$') {
    if (currentValue in theme.referenceIndex) {
      value = theme.referenceIndex[currentValue];
      updated = true;
    } else {
      consoleWarn("Was not able to replace token \"".concat(currentValue, "\"").concat(where ? " at ".concat(prefix ? "".concat(prefix, ".") : '').concat(where.join('.')) : ''));
    }
  }

  return {
    value: value,
    updated: updated
  };
};